import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { ActionsCell } from './actions-cell';
import { messages } from '../messages';
import style from '../style.module.css';

export const createActionsColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'actions',
  Header: <FormattedMessage {...messages.actionsColumnHeader} />,
  Cell: ActionsCell,
  width: 1,
  minWidth: 100,
  className: style['actions-cell'],
});
